import { j as c } from "./theme-colors-uK40SfO5.mjs";
const n = {
  brandColor: "#599D15",
  info: "#007db4",
  infoDark: "#00618b",
  infoLight: "#e6f5fe",
  danger: "#de1429",
  dangerDark: "#ae0718",
  dangerLight: "#fdeaec",
  error: "#de1429",
  errorDark: "#ae0718",
  errorLight: "#fdeaec",
  attention: "#cd4a00",
  attentionDark: "#9e4d00",
  attentionLight: "#fff1e5",
  warning: "#cd4a00",
  warningDark: "#a14300",
  warningLight: "#fff1e5",
  success: "#028a01",
  successDark: "#016d00",
  successLight: "#e8fde8",
  discovery: "#9853b9",
  discoveryDark: "#683180",
  discoveryLight: "#f9edff",
  action: "#fcc400",
  link: "#0b4fd1",
  noticeDark: "#fcc400",
  white: "#fff",
  gray05: "#f6f6f4",
  gray1: "#f5f4f1",
  gray2: "#e4e3e0",
  gray3: "#d4d2d0",
  gray4: "#c6c2bf",
  gray5: "#868180",
  gray6: "#777270",
  gray7: "#676260",
  gray8: "#48413f",
  gray9: "#38312f",
  gray10: "#38312f"
}, D = {
  colors: n
}, o = {
  info: "#0772b3",
  infoDark: "#004279",
  infoLight: "#e6f5fe",
  danger: "#c20b0b",
  dangerDark: "#890000",
  dangerLight: "#fee7e7",
  attention: "#bd5800",
  attentionDark: "#872B00",
  attentionLight: "#fff1e5",
  success: "#0e840d",
  successDark: "#005600",
  successLight: "#e8fde8",
  action: "#ffe30a",
  white: "#fff",
  gray1: "#f4f4f4",
  gray2: "#ebebeb",
  gray3: "#e0e0e0",
  gray4: "#ccc",
  gray5: "#adadad",
  gray6: "#999",
  gray7: "#686868",
  gray8: "#555",
  gray9: "#444",
  gray10: "#222"
}, u = {
  colors: o
}, { themeColors: h } = c, l = "lime1", a = h.find((e) => e.name === l) || h[0];
function r(e, s) {
  e = e.replace("#", "");
  const i = parseInt(e.length === 3 ? e.slice(0, 1).repeat(2) : e.slice(0, 2), 16), f = parseInt(e.length === 3 ? e.slice(1, 2).repeat(2) : e.slice(2, 4), 16), g = parseInt(e.length === 3 ? e.slice(2, 3).repeat(2) : e.slice(4, 6), 16);
  return s ? `rgba(${i}, ${f}, ${g}, ${s})` : `rgb(${i}, ${f}, ${g})`;
}
const t = {
  themeBaseDefault: a.base,
  themeDarkDefault: a.dark,
  themeLightDefault: a.light,
  themeLighterDefault: a.lighter,
  themeLightestDefault: a.lightest,
  themeLightest10Default: r(a.lightest, "0.1"),
  themeLightest35Default: r(a.lightest, "0.35"),
  themeLightest50Default: r(a.lightest, "0.5")
}, m = {
  themeBase: `var(--fabric-theme-base, ${t.themeBaseDefault})`,
  themeDark: `var(--fabric-theme-dark, ${t.themeDarkDefault})`,
  themeLight: `var(--fabric-theme-light, ${t.themeLightDefault})`,
  themeLighter: `var(--fabric-theme-lighter, ${t.themeLighterDefault})`,
  themeLightest: `var(--fabric-theme-lightest, ${t.themeLightestDefault})`,
  themeLightest10: `var(--fabric-theme-lightest10, ${t.themeLightest10Default})`,
  themeLightest35: `var(--fabric-theme-lightest35, ${t.themeLightest35Default})`,
  themeLightest50: `var(--fabric-theme-lightest50, ${t.themeLightest50Default})`
}, L = {
  ...t,
  ...m
};
export {
  o as a,
  u as b,
  n as c,
  r as h,
  D as j,
  L as t
};
//# sourceMappingURL=encore-theme-Bgi7jWdM.mjs.map
